'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/ControlBase.css');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _utilsLib = require('utils-lib');

var _modelsLib = require('models-lib');

var _Vas = require('../Vas');

var _Vas2 = _interopRequireDefault(_Vas);

var _MessageBox = require('./MessageBox');

var _MessageBox2 = _interopRequireDefault(_MessageBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import T from 'i18n-react';
//var data = require('../../public/elements/i18n/de.json');
//T.setTexts(data);

/*
Pflichtproperties:
AppURL={Vas.ApplicationUrl} 
me={this} Id={"name"} ref={"name"} name="name"
IsRequired={true/false} Editable={true/false}  
Label={ Vas.Resources.Labels["Name"]} 
TitleMessageNotValidCharacter={Vas.Resources.Labels["Note"]} 
MessageNotValidCharacter={Vas.Resources.Labels["NotValidCharacter"]} 

optional:
Modus={"Name"} Tooltip={Vas.Resources.Tooltips["Name"]} OnChange={()=>{ this.setState({ Name:  $("#name").val() })}}
Autocomplete={false/true}=>"off"/"on"
*/
var IbanField = function (_Component) {
    _inherits(IbanField, _Component);

    function IbanField(props) {
        _classCallCheck(this, IbanField);

        var _this = _possibleConstructorReturn(this, (IbanField.__proto__ || Object.getPrototypeOf(IbanField)).call(this, props));

        _this.state = {};
        _this.state.isrequired = _this.props.IsRequired;
        _this.state.required = true;
        _this.state.editable = _this.props.Editable;
        _this.state.Label = _this.props.Label;
        _this.state.Value = _this.props.Value;
        _this.state.Placeholder = _this.props.Placeholder;
        _this.state.OnKeyDown = _this.props.OnKeyDown;
        _this.state.OnChange = _this.props.OnChange;
        _this.state.autocomplete = _this.props.Autocomplete;
        _this.state.IbanValid = false;

        _this.BankModel = new _modelsLib.BankDetailsModel([_this]);
        _this.Request = new _modelsLib.RequestAjaxClass(function (error) {
            _this.props.ErrorHandlingPage(error);
        }, null);
        return _this;
    }

    _createClass(IbanField, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.Request.setAuth(false);
            this.Request.setApiKey(this.props.ApiKey);
            this.Request.setApiUrl(this.props.ApiUrl);

            this.BankModel.SetRequest(this.Request);
        }
    }, {
        key: 'Update',
        value: function Update(observer) {
            var me = this;
            this.setState({}, function () {
                if (observer === "BankDetails") {
                    var name = '';
                    var bic = '';
                    if (me.BankModel.BankDetails.IsValid === true) {
                        if (me.BankModel.BankDetails.BankCode) {
                            name = me.BankModel.BankDetails.BankName;
                            bic = me.BankModel.BankDetails.Bic;
                            me.setState({ IbanValid: true, BankName: name, Bic: bic }, function () {
                                if (me.props.OnBlur) {
                                    me.props.OnBlur();
                                }
                            });
                        } else {
                            me.setState({ IbanValid: true, BankName: null, Bic: null }, function () {
                                if (me.props.OnBlur) {
                                    me.props.OnBlur();
                                }
                            });
                        }
                    } else {
                        me.setState({ IbanValid: false, BankName: null, Bic: null }, function () {
                            if (me.props.OnBlur) {
                                me.props.OnBlur();
                            }
                        });
                    }
                }
            });
        }
    }, {
        key: 'checkValue',
        value: function checkValue(me) {
            var iban = (0, _jquery2.default)('#' + this.props.Id).val();
            var ibanCountry = iban.substr(0, 2).toUpperCase();
            switch (ibanCountry) {
                case 'AL':
                case 'AD':
                case 'BE':
                case 'BA':
                case 'BG':
                case 'DK':
                case 'DE':
                case 'EE':
                case 'FI':
                case 'FR':
                case 'GI':
                case 'GR':
                case 'GB':
                case 'IE':
                case 'IS':
                case 'IT':
                case 'HR':
                case 'LV':
                case 'LI':
                case 'LT':
                case 'LU':
                case 'MT':
                case 'MK':
                case 'MC':
                case 'ME':
                case 'NL':
                case 'NO':
                case 'AT':
                case 'PL':
                case 'PT':
                case 'RO':
                case 'RU':
                case 'SM':
                case 'SE':
                case 'CH':
                case 'RS':
                case 'SK':
                case 'SI':
                case 'ES':
                case 'CZ':
                case 'TN':
                case 'TR':
                case 'UG':
                case 'HU':
                case 'BY':
                case 'CY':
                    {
                        var string = iban.substr(2, iban.length);
                        if (_utilsLib.CheckValues.CheckNumber(string) === true) {
                            this.Request.setErrorHandler(function () {
                                me.setState({ IbanValid: false, BankName: null, Bic: null }, function () {
                                    if (me.props.OnBlur) {
                                        me.props.OnBlur();
                                    }
                                });
                            });

                            this.BankModel.CheckIban(iban);
                        } else {
                            if (iban.indexOf(' ') >= 0) {
                                _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                                    Message: _Vas2.default.getText('Labels', 'NoteIban'),
                                    Title: _Vas2.default.getText("Titles", "Note"),
                                    Field: me.props.Id
                                }), document.getElementById('messageContainer'));
                            }
                            me.setState({ IbanValid: false, BankName: null, Bic: null }, function () {
                                if (me.props.OnBlur) {
                                    me.props.OnBlur();
                                }
                            });
                        }
                        break;
                    }
                default:
                    {
                        me.setState({ IbanValid: false, BankName: null, Bic: null }, function () {
                            if (me.props.OnBlur) {
                                me.props.OnBlur();
                            }
                        });
                    }
            }
        }
    }, {
        key: 'getValid',
        value: function getValid() {
            return [this.state.IbanValid, this.state.BankName, this.state.Bic];
        }
    }, {
        key: 'tab',
        value: function tab(event, me) {
            if (event) {
                if (event.keyCode === 13 || event.keyCode === 9) {
                    (0, _jquery2.default)("#" + me.props.Id).val(_utilsLib.XssFilter.getText((0, _jquery2.default)("#" + me.props.Id).val()));
                    me.checkFields();

                    var filled = true;

                    if (me.state.isrequired) {
                        if ((0, _jquery2.default)("#" + me.props.Id).val().length === 0) {
                            filled = false;
                        } else {
                            filled = true;
                        }
                    }
                    if (filled === true) {
                        // filled = this.checkValue(me);
                    }

                    var docs = document.querySelectorAll('div.ss-selected-option,input,button,select');
                    var maxId = docs.length;
                    var aktive = document.activeElement.id;
                    var i = void 0;
                    for (i = 0; i <= maxId - 1; i++) {
                        if (docs[i].id === aktive) {
                            if (i === maxId - 1) {
                                docs[i].blur();
                                break;
                            } else {
                                if (event.shiftKey && event.keyCode === 9) {
                                    for (var j = i - 1; j >= 0; j--) {
                                        if (!docs[j].readOnly) {
                                            docs[j].focus();
                                            break;
                                        } else if (docs[j].className === "ss-selected-option") {
                                            var _event = new Event("click");
                                            docs[j].dispatchEvent(_event);
                                            break;
                                        }
                                    }
                                } else {
                                    for (var _j = i + 1; _j <= maxId - 1; _j++) {
                                        if (!docs[_j].readOnly) {
                                            docs[_j].focus();
                                            break;
                                        } else if (docs[_j].className === "ss-selected-option") {
                                            var _event2 = new Event("click");
                                            docs[_j].dispatchEvent(_event2);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    me.setState({ required: filled });
                } else if (event.keyCode === undefined) {
                    (0, _jquery2.default)("#" + me.props.Id).val(_utilsLib.XssFilter.getText((0, _jquery2.default)("#" + me.props.Id).val()));
                    me.checkFields();
                    var _filled = true;
                    if (me.state.isrequired) {
                        if ((0, _jquery2.default)("#" + me.props.Id).val().length === 0) {
                            _filled = false;
                        } else {
                            _filled = true;
                        }
                    }

                    //filled = this.checkValue(me);
                    me.setState({ required: _filled });
                } else if (event.keyCode === 8 || event.keyCode === 46) {
                    if ((0, _jquery2.default)("#" + me.props.Id).val().length === 0) {
                        me.setState({ Placeholder: null });
                    }
                }
            }
        }
    }, {
        key: 'checkFields',
        value: function checkFields() {
            if (this.props.me) {
                var docs = document.querySelectorAll('select,input');
                var docRefs = this.props.me.refs;
                _utilsLib.CheckValues.checkAllFields(docs, docRefs, this.props.Id);
            }
        }
    }, {
        key: 'focus',
        value: function focus(id) {
            (0, _jquery2.default)("#" + id).select();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var Tooltip = _react2.default.createElement(
                'span',
                { id: this.props.Id + "Tooltip" },
                this.props.Tooltip ? this.props.Tooltip : _Vas2.default.getText('Tooltips', 'Iban')
            );
            var controlClassName = "textfield";

            var FieldNotFilled = "";
            var isTextFieldFilled = true;

            if (this.props.FieldNotFilledHint && this.props.FieldNotFilledHint !== "") {
                FieldNotFilled = _react2.default.createElement(
                    'div',
                    { id: this.props.Id + "FieldNotFilled", className: "fieldNotFilled" },
                    this.props.FieldNotFilledHint
                );
            }

            var Style = null;

            if (this.props.Width) {
                Style = { width: this.props.Width, float: this.props.Float };
            }

            var readOnly = false;

            if (this.state.editable) {

                if (this.state.isrequired) {
                    if (this.state.required) {
                        controlClassName = "textfield";
                        readOnly = false;
                    } else {
                        controlClassName = "textfieldNotFilled";
                        readOnly = false;
                        isTextFieldFilled = false;
                    }
                } else {
                    controlClassName = "textfield";
                    readOnly = false;
                }
            } else {
                controlClassName = "textfieldDisabled";
                readOnly = true;
            }
            var type = "text";

            if (this.props.Type) {
                type = this.props.Type;
            }

            var autocom = "on";
            if (this.state.autocomplete) {
                if (this.state.autocomplete === false) {
                    autocom = "off";
                }
            }

            var iconRed = '';
            var iconGreen = '';
            if (this.state.IbanValid === true) {
                iconGreen = _react2.default.createElement(_Icon2.default, {
                    Align: "left",
                    Color: "green",
                    Name: "Done",
                    Size: 24
                });
            } else {
                iconRed = _react2.default.createElement(_Icon2.default, {
                    Align: "left",
                    Color: "red",
                    Name: "Warning",
                    Size: 24
                });
            }

            var isTextFieldFilledStyle = { visibility: 'hidden' };

            if (!isTextFieldFilled) {
                isTextFieldFilledStyle = { visibility: 'visible' };
            }

            return _react2.default.createElement(
                'div',
                { style: Style, className: "if" },
                _react2.default.createElement(
                    'label',
                    {
                        className: 'textfieldLabel',
                        style: Style,
                        id: this.props.Id + "Label",
                        'for': this.props.Id },
                    this.state.Label,
                    ' ',
                    "(",
                    ' ',
                    _Vas2.default.getText("Labels", "NoteIban"),
                    ' ',
                    ")",
                    ' ',
                    Tooltip
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'table',
                        null,
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('input', {
                                        onBlur: function onBlur(e) {
                                            _this2.checkValue(_this2);_this2.tab(e, _this2);
                                        },
                                        onKeyDown: function onKeyDown(e) {
                                            if (e.keyCode === 9) {
                                                e.preventDefault();
                                            }if (_this2.state.OnKeyDown) {
                                                _this2.state.OnKeyDown();
                                            }_this2.tab(e, _this2);
                                        },
                                        onChange: function onChange() {
                                            if (_this2.state.OnChange) {
                                                _this2.state.OnChange();
                                            }
                                        },
                                        style: Style,
                                        onFocus: function onFocus() {
                                            _this2.focus(_this2.props.Id);
                                        },
                                        onInput: this.props.onInput,
                                        id: this.props.Id,
                                        type: type,
                                        className: controlClassName,
                                        value: this.state.Value,
                                        placeholder: this.state.Placeholder,
                                        readOnly: readOnly,
                                        tabIndex: this.props.Tabindex,
                                        autoComplete: autocom })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    iconRed,
                                    iconGreen
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: this.props.Id + "FieldNotFilled", style: isTextFieldFilledStyle },
                    FieldNotFilled
                )
            );
        }
    }]);

    return IbanField;
}(_react.Component);

exports.default = IbanField;